export default function ExpectationsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100" id="beklenti">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-primary-500 p-8 md:p-12 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-48 h-48 bg-accent-500/10 rounded-full -translate-y-1/3 translate-x-1/3 blur-3xl"></div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
              Garanti Satış Sözü Değil,
              <br />
              <span className="text-accent-400">Veriyle Optimize Edilen Bir Sistem</span>
            </h2>
            <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-8 max-w-2xl">
              Hiçbir reklam çalışmasında garanti satış sözü vermek doğru değildir. Bizim amacımız tahminle reklam yönetmek değil; gelen kişilerin davranışları, geri dönüşleri, satışa yakınlıkları ve gerçek firma verileriyle sistemi optimize etmektir.
            </p>
            <p className="text-background-50/70 text-sm leading-relaxed max-w-2xl">
              İlk ay sonunda hedefimiz şu sorulara daha net cevap bulabilmektir: Reklama ayırdığınız bütçe nasıl dönüş getiriyor? Hangi müşteri tipi daha kaliteli? Hangi mesajlar daha iyi çalışıyor? Hangi kitleler satışa daha yakın? Hangi başvurular gerçekten takip edilmeye değer?
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}